import {Button} from '@nlabs/gothamjs';

import ufatCodingLeafHero from '../../assets/ufat-coding-leaf-hero.png';
import {Hero} from '../../components/Hero';
import {Page} from '../../components/Page';
import {RotatingHeroTitle} from '../../components/RotatingHeroTitle';
import {Section} from '../../components/Section';
import {ServiceCard} from '../../components/ServiceCard';
import {CODING_HERO_TITLES} from '../../data/heroTitles';
import {navigate} from '../../lib/navigation';
import {SUPPORT_EMAIL} from '../../lib/site';
import {button, gridThree, heroActionLink} from '../../lib/styles';
import {Route} from '../../types/routes';

export const Coding = ({route}: {route: Route}) => (
  <Page route={route}>
    <Hero
      actions={(
        <>
          <Button className={button} onClick={() => navigate('/support')}>Request Support</Button>
          <a className={heroActionLink} href={`mailto:${SUPPORT_EMAIL}`}>Start a Project</a>
        </>
      )}
      backgroundImage={ufatCodingLeafHero}
      imageLabel="Development placeholder image"
      kicker="UFAT Labs, Inc."
      subtitle="UFAT creates modern web platforms, APIs, cloud services, business systems, and AI-powered tools designed for long-term scalability."
      title={<RotatingHeroTitle items={CODING_HERO_TITLES} />}
      tone="green"
    />
    <Section className="nx-dark nx-section-coding" title="Services">
      <div className={gridThree}>
        <ServiceCard body="Product planning, interface structure, frontend implementation, and launch support." title="UI/UX and Web Apps" />
        <ServiceCard body="Mobile product builds and responsive application experiences ready for real-world workflows." title="Mobile Development" />
        <ServiceCard body="Serverless APIs, AWS integrations, deployment pipelines, and ArangoDB-backed services." title="Cloud Systems" />
        <ServiceCard body="Technical guidance, product architecture, integration planning, and delivery support." title="Consulting" />
        <ServiceCard body="Marketing pages, support surfaces, admin tools, and customer portals under one codebase." title="Web Platforms" />
        <ServiceCard body="Placeholder support ticketing now, with a deploy-ready API path for later persistence." title="Support" />
      </div>
    </Section>
  </Page>
);
